var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35889 2.81131H3.00492C3.29908 2.81131 3.53758 2.5728 3.53758 2.27864C3.53758 1.98436 3.29908 1.74598 3.00492 1.74598L2.35889 1.74585C1.33213 1.74611 0.500259 2.57785 0.5 3.60474V9.1466C0.500259 10.1734 1.33213 11.0051 2.35889 11.0054H7.90075C8.92751 11.0052 9.75925 10.1734 9.75951 9.1466V8.50057C9.75951 8.20628 9.521 7.96777 9.22671 7.96777C8.93243 7.96777 8.69392 8.20628 8.69392 8.50057V9.1466C8.69314 9.58453 8.33855 9.93899 7.90062 9.9399H2.35889C1.92096 9.93899 1.56636 9.58453 1.56559 9.1466V3.60474C1.56636 3.16668 1.92096 2.81221 2.35889 2.81131Z",
    fill: "#43927C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95051 6.54411C5.1586 6.75208 5.49598 6.75208 5.70395 6.54411L10.4345 1.81342V5.08873C10.4345 5.38289 10.673 5.62153 10.9673 5.62153C11.2616 5.62153 11.5001 5.38289 11.5001 5.08873V0.527179C11.5001 0.457942 11.4861 0.389095 11.4595 0.324259C11.4328 0.259552 11.3939 0.200022 11.344 0.150328C11.2942 0.100633 11.2348 0.0615501 11.1702 0.0350204C11.1053 0.00836134 11.0363 -0.00561523 10.9671 -0.00561523H6.40576C6.11147 -0.00561523 5.87296 0.232893 5.87296 0.527179C5.87296 0.821334 6.11147 1.05997 6.40576 1.05997V1.05984H9.68107L4.95051 5.79041C4.74241 5.99864 4.74241 6.33589 4.95051 6.54411Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.90beaca263f43697d2f80ce40bbbefa7.svg";
export { ForwardRef as ReactComponent };